export default __webpack_public_path__ + "images/differentiation.94272642.png";